var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['tw:rounded-lg tw:flex tw:flex-col tw:transition-all tw:duration-150 tw:gap-2', _vm.variant, _vm.customClass, _vm.padding]},[_vm._t("skeleton")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }